// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__fU_pn","SocialMedia":"Footer_SocialMedia__2WGbu","Copyright":"Footer_Copyright__UqQjl"};